import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Compbaser} from "../../../../components/compbaser";
import {SceneAddBlocksComponent} from "../scene-add-component/scene-add-blocks.component";

@Component({
    selector: 'app-scene-add-component-dialog',
    templateUrl: './scene-add-component-dialog.html',
    styleUrls: ['./scene-add-component-dialog.scss']
})
export class SceneAddComponentDialog extends Compbaser implements OnInit {

    m_data;

    constructor(public dialogRef: MatDialogRef<SceneAddBlocksComponent>, @Optional() @Inject(MAT_DIALOG_DATA) data) {
        super();
        if (data) {
            this.m_data = data;
        }
    }

    ngOnInit(): void {
    }

    onCloseVerboseDialog() {
        this.dialogRef.close();
    }
}

